import React from "react";
import { Select, MenuItem, Tooltip, ListItemText } from "@mui/material";
import "./style.css";

const CustomSelect = ({
  className = "",
  value = "", // Initialize value to avoid undefined issues
  onChange,
  disabled = false,
  options = [],
  placeholder = "Select",
  maxMenuHeight = 250,
  maxMenuWidth = 250,
  style,
  customClasses = {},
}) => {
  return (
    <Select
      className={className}
      value={value} // Use value for controlled behavior
      onChange={(el) => onChange(el?.target?.value || "")}
      disabled={disabled}
      classes={customClasses}
      
      style={style}
      MenuProps={{
        PaperProps: {
          style: { maxHeight: maxMenuHeight, maxWidth: maxMenuWidth },
        },
      }}
      displayEmpty
      renderValue={(selected) => {
        if (!selected) {
          return (
            <span style={{ opacity: "0.5", fontSize: "14px" }}>
              {placeholder}
            </span>
          );
        }
        const found = options.find((el) => el.value === selected);
        return found ? found.title : value;
      }}
    >
      {options.map((item) => (
        <MenuItem
          key={item.value}
          value={item.value}
          disabled={item.disabled}
          className="customSelect"
          style={{ padding: "5px 10px", height: "40px" }}
        >
          <div className="selectlistItem" style={{ maxWidth: "300px" }}>
            {item.title.length > 30 ? (
              <Tooltip title={item.title}>
                <ListItemText primary={item.title} />
              </Tooltip>
            ) : (
              <ListItemText primary={item.title} />
            )}
          </div>
        </MenuItem>
      ))}
    </Select>
  );
};

export default CustomSelect;
